import { render, staticRenderFns } from "./FreeModeAlertForPresets.vue?vue&type=template&id=4b1f6aa0&"
import script from "./FreeModeAlertForPresets.vue?vue&type=script&lang=ts&"
export * from "./FreeModeAlertForPresets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports